import React, { useEffect, useMemo, useRef, useState } from 'react';

import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { ExamPartQuestion } from '../../../../model/response';
import { getDetailLetter } from '../../../../utils/utils';

interface QuestionGuideViewProps {
  examPartQuestion: ExamPartQuestion;
  children?: ExamPartQuestion[];
  scrollToQuestion?: (questionElement: HTMLDivElement) => void;
  groupIndex?: number;
  firstExamPartQuestionId?: string | null;
  examPartQuestionIndexMap: Map<string, number>;
}

function QuestionGuideView({
  examPartQuestion,
  children = [],
  scrollToQuestion,
  groupIndex,
  firstExamPartQuestionId,
  examPartQuestionIndexMap,
}: QuestionGuideViewProps) {
  const [showGuide, setShowGuide] = useState(firstExamPartQuestionId === examPartQuestion.id);
  const questionGuideRef = useRef<HTMLDivElement | null>(null);

  const prefix = useMemo(() => {
    if (groupIndex !== undefined && examPartQuestion.question.type === 'YES_NO_QUESTION') {
      return `<span class='font-medium'>${getDetailLetter(groupIndex, 'YES_NO_QUESTION')} </span>`;
    }
    const questionIndex = examPartQuestionIndexMap.get(examPartQuestion.id);
    return questionIndex === undefined ? '' : `<span class='font-bold'>Câu ${questionIndex + 1}: </span>`;
  }, [examPartQuestion.id, examPartQuestion.question.type, examPartQuestionIndexMap, groupIndex]);

  useEffect(() => {
    if (showGuide) {
      const renderMathJax = () => {
        const win: any = window;
        win.MathJax.typesetPromise()
          .then(() => {})
          .catch((err: any) => {
            console.error('Error rendering MathJax: ', err);
          });
      };

      setTimeout(renderMathJax, 800);
    }
  }, [showGuide]);

  return (
    <div ref={questionGuideRef}>
      <div dangerouslySetInnerHTML={{ __html: prefix + examPartQuestion.question.topic }} />
      <div
        className={'text-0B7BFF flex gap-x-1 items-center cursor-pointer'}
        onClick={() => setShowGuide((old) => !old)}
      >
        <span>{showGuide ? 'Ẩn lời giải' : 'Hiện lời giải'}</span>
        {showGuide ? (
          <UpOutlined className={'text-light-blue text-sm'} />
        ) : (
          <DownOutlined className={'text-light-blue text-sm'} />
        )}
      </div>
      {showGuide ? (
        <div className={'mt-1'} dangerouslySetInnerHTML={{ __html: examPartQuestion.question.solutionGuide }} />
      ) : null}
      <div className={'ml-4 mt-2 flex flex-col gap-y-1'}>
        {children.map((child, index) => (
          <QuestionGuideView
            examPartQuestion={child}
            key={child.id}
            groupIndex={index}
            scrollToQuestion={scrollToQuestion}
            examPartQuestionIndexMap={examPartQuestionIndexMap}
          />
        ))}
      </div>
    </div>
  );
}

export default QuestionGuideView;
